import React from 'react'

import { humanize, strLeftBack, titleize } from 'underscore.string'

export const humanizeFilename = (s) => titleize(humanize(strLeftBack(s, '.')))

export const breakLine = (text) => {
  const br = React.createElement('br')
  var regex = /(<br \/>)/g
  return text.split(regex).map((line, index) =>
    line.match(regex) ? <br key={'key' + index} /> : line
  )
}



// WEBPACK FOOTER //
// ./src/lib/formatter.js